<template>
  <div class="question-container">
    <!-- 查询控件卡片 -->
    <el-card class="filter-card">
      <div class="filter-container">
        <!-- 左侧查询表单 -->
        <div class="left-section">
          <el-form :inline="true" :model="filterForm" class="filter-form" size="small">
            <div class="form-content">
              <!-- 题目名称 -->
              <el-form-item>
                <el-input
                  v-model="filterForm.question_name"
                  placeholder="题目名称"
                  clearable
                  @keyup.enter.native="handleSearch"
                  style="width: 150px">
                </el-input>
              </el-form-item>
              
              <!-- 赛事名称 -->
              <el-form-item>
                <el-input
                  v-model="filterForm.game_name"
                  placeholder="赛事名称"
                  clearable
                  @keyup.enter.native="handleSearch"
                  style="width: 150px">
                </el-input>
              </el-form-item>
              
              <!-- 订正状态 -->
              <el-form-item>
                <el-select
                  v-model="filterForm.fix_status"
                  placeholder="订正状态"
                  clearable
                  style="width: 100px">
                  <el-option label="已完成" value="已完成"></el-option>
                  <el-option label="未完成" value="未完成"></el-option>
                </el-select>
              </el-form-item>
              
              <!-- 挂起状态 -->
              <el-form-item>
                <el-select
                  v-model="filterForm.is_pending"
                  placeholder="挂起状态"
                  clearable
                  style="width: 100px">
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>

              <!-- 题目难度 -->
              <el-form-item>
                <el-select
                  v-model="filterForm.difficulty"
                  placeholder="题目难度"
                  clearable
                  style="width: 100px">
                  <el-option label="未定义" value="未定义"></el-option>
                  <el-option label="红题" value="红题"></el-option>
                  <el-option label="橙题" value="橙题"></el-option>
                  <el-option label="黄题" value="黄题"></el-option>
                  <el-option label="绿题" value="绿题"></el-option>
                  <el-option label="蓝题" value="蓝题"></el-option>
                  <el-option label="紫题" value="紫题"></el-option>
                  <el-option label="黑题" value="黑题"></el-option>
                </el-select>
              </el-form-item>

              <!-- 错误类型（单选） -->
              <el-form-item>
                <el-select
                  v-model="filterForm.error_code"
                  placeholder="错误类型"
                  clearable
                  style="width: 150px">
                  <el-option
                    v-for="err in errorCodes"
                    :key="err.error_code"
                    :label="err.error_name"
                    :value="err.error_code">
                  </el-option>
                </el-select>
              </el-form-item>
              
              <!-- 标签选择器 -->
              <el-form-item>
                <el-select
                  v-model="filterForm.tags"
                  multiple
                  filterable
                  placeholder="标签"
                  style="width: 150px">
                  <el-option
                    v-for="tag in sortedTags"
                    :key="tag.tag_code"
                    :label="tag.tag_name"
                    :value="tag.tag_name">
                    <el-tag
                      :style="{ 
                        backgroundColor: getTagColorByCode(tag.tag_code),
                        borderColor: getTagColorByCode(tag.tag_code),
                        color: 'white'
                      }"
                      style="margin-right: 4px">
                      {{ tag.tag_name }}
                    </el-tag>
                  </el-option>
                </el-select>
              </el-form-item>
              
              <!-- 收藏状态 -->
              <el-form-item>
                <el-select
                  v-model="filterForm.is_collect"
                  placeholder="收藏状态"
                  clearable
                  style="width: 100px">
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
              
              <el-form-item class="filter-buttons">
                <el-button @click="handleReset">重置</el-button>
                <el-button type="primary" @click="handleSearch">查询</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <!-- 右侧数据展示 -->
        <div class="right-section">
          <!-- 总题数 -->
          <div class="stat-card">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">总题数</div>
          </div>

          <!-- 平均分 -->
          <div class="stat-card">
            <div class="stat-value">{{ averageScore.toFixed(2) }}</div>
            <div class="stat-label">平均分</div>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 数据表格卡片 -->
    <el-card class="table-card">
      <el-table
        v-loading="loading"
        :data="questionList"
        stripe
        style="width: 100%"
        :header-cell-style="{
          background: '#f2f3f5',
          color: '#606266',
          fontWeight: '600',
          fontSize: '14px',
          height: '52px',
          padding: '0'
        }"
        @sort-change="handleSortChange">
        
        <!-- 序号列 -->
        <el-table-column
          type="index"
          label="序号"
          width="60"
          align="center">
          <template slot-scope="scope">
            {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        
        <!-- 题目名称 -->
        <el-table-column
          prop="question_name"
          label="题目名称"
          sortable="custom"
          min-width="160">
          <template slot-scope="{row}">
            <el-tooltip 
              :content="row.question_name" 
              placement="top" 
              :open-delay="300"
              :disabled="!row.question_name || row.question_name.length < 15">
              <div class="text-ellipsis">
                <a v-if="row.question_url" 
                   :href="row.question_url" 
                   target="_blank"
                   class="link-text">
                  {{ row.question_name }}
                </a>
                <span v-else>{{ row.question_name }}</span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        
        <!-- 赛事名称 -->
        <el-table-column
          prop="game_name"
          label="赛事名称"
          sortable="custom"
          min-width="210">
          <template slot-scope="{row}">
            <el-tooltip 
              :content="row.game_name" 
              placement="top" 
              :open-delay="300"
              :disabled="!row.game_name || row.game_name.length < 20">
              <div class="text-ellipsis">
                <a v-if="row.game_url" 
                   :href="row.game_url" 
                   target="_blank"
                   class="link-text">
                  {{ row.game_name }}
                </a>
                <span v-else>{{ row.game_name }}</span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        
        <!-- 题号 -->
        <el-table-column
          prop="question_seq"
          label="题号"
          width="50">
        </el-table-column>
        
        <!-- 得分 -->
        <el-table-column
          prop="question_score"
          label="得分"
          sortable="custom"
          width="110"
          align="center">
          <template slot-scope="scope">
            <div class="score-cell">
              <i v-if="scope.row.question_score === 100" 
                 class="el-icon-medal-1" 
                 :style="{ color: getScoreColor(scope.row.question_score), marginRight: '4px' }"></i>
              <span :style="{ color: getScoreColor(scope.row.question_score), fontWeight: 'bold' }">
                {{ scope.row.question_score }}
              </span>
            </div>
          </template>
        </el-table-column>
        
        <!-- 订正分数 -->
        <el-table-column
          prop="question_score_fix"
          label="订正分数"
          sortable="custom"
          width="110"
          align="center">
          <template slot-scope="scope">
            <div class="score-cell">
              <i v-if="scope.row.question_score_fix === 100" 
                 class="el-icon-medal-1" 
                 :style="{ color: getScoreColor(scope.row.question_score_fix), marginRight: '4px' }"></i>
              <span :style="{ color: getScoreColor(scope.row.question_score_fix), fontWeight: 'bold' }">
                {{ scope.row.question_score_fix }}
              </span>
            </div>
          </template>
        </el-table-column>
        
        <!-- 题目难度 -->
        <el-table-column
          prop="question_level"
          label="题目难度"
          sortable="custom"
          width="110"
          align="center">
          <template slot-scope="{row}">
            <el-tag
              :style="{ 
                backgroundColor: getDifficultyColor(row.question_level || '未定义'),
                borderColor: getDifficultyColor(row.question_level || '未定义'),
                color: 'white',
                height: '28px',
                lineHeight: '26px'
              }"
              size="small">
              {{ row.question_level || '未定义' }}
            </el-tag>
          </template>
        </el-table-column>
        
        <!-- 错误类型 -->
        <el-table-column
          prop="errors"
          label="错误类型"
          sortable="custom"
          min-width="170">
          <template slot="header" slot-scope="scope">
            <span>错误类型</span>
            <el-tooltip effect="dark" placement="top" popper-class="difficulty-tooltip">
              <div slot="content" class="difficulty-tooltip-content">
                <div class="difficulty-description">
                  <p><strong>1. 算法未掌握</strong>：未掌握核心知识点、算法原理或其适用性；</p>
                  <ul>
                    <li>【学透】深入理解定义、原理、推导、复杂度</li>
                    <li>【对比】区分相似概念，明确应用场景</li>
                    <li>【复习】定期回顾基础知识</li>
                  </ul>
                  <p><strong>2. 思路/逻辑偏差</strong>：思路框架或解题逻辑有缺陷，无法构建正确解题路径；</p>
                  <ul>
                    <li>【拆解】将问题分解，逐个击破</li>
                    <li>【模拟】用小数据手动演算，验证思路</li>
                    <li>【学习】学习他人优秀解法，寻找更优思路</li>
                  </ul>
                  <p><strong>3. 实现/细节错误</strong>：思路正确，但代码细节处理不当，导致程序出错；</p>
                  <ul>
                    <li>【细抠】关注边界、初始化、数据类型、语句逻辑</li>
                    <li>【调试】熟练使用调试器，定位问题</li>
                    <li>【规范】养成良好的编码习惯</li>
                  </ul>
                  <p><strong>4. 效率/复杂度问题</strong>：算法或实现效率低，导致超时 (TLE) 或超内存 (MLE)；</p>
                  <ul>
                    <li>【估算】优先评估算法时间/空间复杂度</li>
                    <li>【优化】学习常用优化技巧（如剪枝、数据结构）</li>
                    <li>【卡点】针对性练习时间/空间敏感题</li>
                  </ul>
                  <p><strong>5. 边界/特殊情况遗漏</strong>：未考虑题目中的特殊数据、极端情况或边界条件；</p>
                  <ul>
                    <li>【预判】思考各种可能的小数据、负数、空集、全同等情况</li>
                    <li>【测试】编写专门测试边界的用例</li>
                    <li>【总结】建立边界条件检查清单</li>
                  </ul>
                  <p><strong>6. 题意理解偏差</strong>：对题目描述、要求、输入输出等理解有误；</p>
                  <ul>
                    <li>【精读】慢读、细读，划出关键词</li>
                    <li>【明确】确认输入输出格式、数据范围、约束条件</li>
                    <li>【举例】用自己的话复述题目</li>
                  </ul>
                  <p><strong>7. 工具/环境问题</strong>：编程语言特性、编译器、IDE、提交系统等非算法本身的细节问题；</p>
                  <ul>
                    <li>【熟悉】了解常用语言特性、库函数用法</li>
                    <li>【检查】留意编译警告，熟悉评测环境</li>
                    <li>【记录】记录常见坑点</li>
                  </ul>
                  <p><strong>8. 心理性错误</strong>：受情绪、心态、比赛压力等因素影响导致的技术失误；</p>
                  <ul>
                    <li>【训练】模拟赛中培养抗压能力</li>
                    <li>【调整】保持积极心态，学会自我鼓励</li>
                    <li>【暂停】遇到困难时，短暂休息，深呼吸</li>
                  </ul>
                  <p><strong>9. 其他/未分类错误</strong>：暂时难以明确归类，或属特定情况的错误；</p>
                  <ul>
                    <li>【分析】尝试将其归入现有分类</li>
                    <li>【记录】暂存，等待进一步研究或求助</li>
                  </ul>
                </div>
              </div>
              <i class="el-icon-question" style="cursor: pointer; margin-left: 4px; font-size: 14px; color: #606266;"></i>
            </el-tooltip>
          </template>
          <template slot-scope="{row}">
            <template v-if="row.question_score === 100">
              <span style="color:#909399;">-</span>
            </template>
            <template v-else>
              <div class="tag-container">
                <template v-if="expandedErrors[row.question_code]">
                  <!-- 展开状态：显示所有 -->
                  <el-tag
                    v-for="err in normalizeErrors(row.errors)"
                    :key="err.error_code || err.error_name"
                    :style="getErrorOutlineStyle(err.error_code || err.error_name)"
                    style="margin-right: 4px; margin-bottom: 4px; height: 28px; line-height: 26px;">
                    <i class="el-icon-warning" style="margin-right: 4px;"></i>{{ err.error_name || err }}
                  </el-tag>
                  <el-button
                    v-if="normalizeErrors(row.errors).length > 1"
                    type="text"
                    class="expand-btn"
                    @click="toggleExpandErrors(row.question_code)">
                    收起
                  </el-button>
                </template>
                <template v-else>
                  <!-- 收起状态：只显示第一个 -->
                  <el-tag
                    v-if="normalizeErrors(row.errors).length > 0"
                    :style="getErrorOutlineStyle(normalizeErrors(row.errors)[0].error_code || normalizeErrors(row.errors)[0].error_name)"
                    style="margin-right: 4px; height: 28px; line-height: 26px;">
                    <i class="el-icon-warning" style="margin-right: 4px;"></i>{{ normalizeErrors(row.errors)[0].error_name || normalizeErrors(row.errors)[0] }}
                  </el-tag>
                  <el-button
                    v-if="normalizeErrors(row.errors).length > 1"
                    type="text"
                    class="expand-btn"
                    @click="toggleExpandErrors(row.question_code)">
                    +{{ normalizeErrors(row.errors).length - 1 }}
                  </el-button>
                </template>
              </div>
            </template>
          </template>
        </el-table-column>

        <!-- 标签列 -->
        <el-table-column
          prop="tags"
          label="标签"
          min-width="180">
          <template slot-scope="{row}">
            <div class="tag-container">
              <template v-if="expandedTags[row.question_code]">
                <!-- 展开状态：显示所有 -->
                <el-tag
                  v-for="tagName in row.tags"
                  :key="tagName"
                  :style="{ 
                    backgroundColor: getTagColorByName(tagName),
                    borderColor: getTagColorByName(tagName),
                    color: 'white',
                    height: '28px',
                    lineHeight: '26px',
                    marginRight: '4px',
                    marginBottom: '4px'
                  }">
                  {{ tagName }}
                </el-tag>
                <el-button
                  v-if="row.tags && row.tags.length > 1"
                  type="text"
                  class="expand-btn"
                  @click="toggleExpandTags(row.question_code)">
                  收起
                </el-button>
              </template>
              <template v-else>
                <!-- 收起状态：只显示第一个 -->
                <el-tag
                  v-if="row.tags && row.tags.length > 0"
                  :style="{ 
                    backgroundColor: getTagColorByName(row.tags[0]),
                    borderColor: getTagColorByName(row.tags[0]),
                    color: 'white',
                    height: '28px',
                    lineHeight: '26px',
                    marginRight: '4px'
                  }">
                  {{ row.tags[0] }}
                </el-tag>
                <el-button
                  v-if="row.tags && row.tags.length > 1"
                  type="text"
                  class="expand-btn"
                  @click="toggleExpandTags(row.question_code)">
                  +{{ row.tags.length - 1 }}
                </el-button>
              </template>
            </div>
          </template>
        </el-table-column>
        
        <!-- 操作 -->
        <el-table-column
          label="操作"
          width="170"
          align="center"
          class-name="operation-column">
          <template slot="default" slot-scope="scope">
            <div class="operation-buttons">
              <el-tooltip content="编辑" placement="top" :enterable="false" :open-delay="100">
                <el-button
                  type="text"
                  class="operation-button edit-button"
                  @click="handleEdit(scope.row)">
                  <i class="el-icon-edit"></i>
                </el-button>
              </el-tooltip>

              <el-tooltip content="订正" placement="top" :enterable="false" :open-delay="100">
                <el-button
                  type="text"
                  class="operation-button"
                  :class="scope.row.question_score_fix === 100 ? 'disabled-button' : 'fix-button'"
                  :disabled="scope.row.question_score_fix === 100"
                  @click="handleFix(scope.row)">
                  <i class="el-icon-check"></i>
                </el-button>
              </el-tooltip>

              <el-tooltip content="复盘" placement="top" :enterable="false" :open-delay="100">
                <el-button
                  type="text"
                  class="operation-button"
                  :class="!scope.row.has_replay ? 'disabled-button' : 'replay-button'"
                  :disabled="!scope.row.has_replay"
                  @click="handleReplay(scope.row)">
                  <i class="el-icon-video-camera"></i>
                </el-button>
              </el-tooltip>

              <el-tooltip :content="scope.row.is_collect ? '取消收藏' : '收藏'" placement="top" :enterable="false" :open-delay="100">
                <el-button
                  type="text"
                  class="operation-button"
                  :class="scope.row.is_collect ? 'collect-active-button' : 'collect-button'"
                  @click="handleCollect(scope.row)">
                  <i :class="{'el-icon-star-off': !scope.row.is_collect, 'el-icon-star-on': scope.row.is_collect}">
                  </i>
                </el-button>
              </el-tooltip>

              <el-tooltip :content="getHangupTooltip(scope.row)" placement="top" :enterable="false" :open-delay="100">
                <el-button
                  type="text"
                  class="operation-button"
                  :class="getHangupButtonClass(scope.row)"
                  :disabled="scope.row.question_score === 100 || scope.row.question_score_fix === 100"
                  @click="handlePending(scope.row)">
                  <i class="el-icon-video-pause">
                  </i>
                </el-button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 版权信息卡片 -->
    <el-card class="copyright-card">
      <div class="copyright-content">
        <span>Copyright © 2024 OIer之路 All rights reserved.  |  闽ICP备2025095302号-1</span>
      </div>
    </el-card>

    <!-- 复盘对话框 -->
    <div class="vertical-center-dialog">
      <el-dialog
        :title="'题目复盘'"
        :visible.sync="replayDialogVisible"
        width="50%"
        class="replay-dialog"
        custom-class="question-replay-dialog-width-limit"
        :append-to-body="false"
        :modal-append-to-body="false"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        :destroy-on-close="true"
        @close="replayDialogVisible = false">
        <div v-if="currentReplayInfo" class="replay-content">
          <mavon-editor 
            :value="currentReplayInfo"
            :subfield="false"
            :defaultOpen="'preview'"
            :toolbarsFlag="false"
            :editable="false"
            :boxShadow="false"
            :navigation="false"
            previewBackground="#fff"
            class="md-editor"
          />
        </div>
        <div v-else class="empty-text">暂无复盘信息</div>
      </el-dialog>
    </div>

    <!-- 题目编辑对话框 -->
    <div class="vertical-center-dialog">
      <question-dialog
        :visible.sync="editDialogVisible"
        :question="currentQuestion"
        :is-edit="true"
        :game-code="currentQuestion ? currentQuestion.game_code : ''"
        @success="handleSuccess"
        @cancel="editDialogVisible = false">
      </question-dialog>
    </div>
  </div>
</template>

<script>
import { getQuestionList, getQuestionReplay, updateQuestionCollect } from '@/api/question'
import { getAllTags } from '@/api/tag'
import QuestionDialog from '@/views/game/components/QuestionDialog.vue'
import request from '@/utils/request'
import { getErrorTagInlineStyle, getErrorOutlineStyle } from '@/constants/errorTypes'
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

export default {
  name: 'Question',
  components: {
    QuestionDialog,
    mavonEditor: mavonEditor.mavonEditor
  },
  data() {
    return {
      loading: false,
      questionList: [],
      total: 0,
      averageScore: 0,  // 平均分
      currentPage: 1,
      pageSize: 20,
      sortProp: 'game_time',
      sortOrder: 'descending',
      
      filterForm: {
        question_name: '',
        game_name: '',
        fix_status: '',
        difficulty: '',
        tags: [],
        is_collect: '',
        is_pending: ''
      },
      
      tags: [],
      errorCodes: [],
      
      replayDialogVisible: false,
      currentReplayInfo: '',
      
      editDialogVisible: false,
      currentQuestion: null,
      
      showMarkdown: true,
      
      expandedErrors: {},  // 记录展开的错误类型 { questionCode: boolean }
      expandedTags: {}     // 记录展开的标签 { questionCode: boolean }
    }
  },
  computed: {
    sortedTags() {
      return [...this.tags].sort((a, b) => a.tag_name.localeCompare(b.tag_name))
    },
    // 使用mavonEditor的markdown渲染
    compiledMarkdown() {
      // 使用mavonEditor的内部渲染方法
      return mavonEditor.markdownIt.render(this.currentReplayInfo || '')
    }
  },
  created() {
    this.fetchData()
    this.fetchTags()
    this.fetchErrorCodes()
  },
  methods: {
    async fetchData(filterParams = {}) {
      this.loading = true
      try {
        // 构建请求参数，始终包含排序参数
        const params = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          sort_prop: this.sortProp,
          sort_order: this.sortOrder,
          ...filterParams
        }
        
        console.log('fetchData - 最终请求参数:', params)
        console.log('fetchData - 当前组件状态:', {
          sortProp: this.sortProp,
          sortOrder: this.sortOrder,
          filterForm: this.filterForm
        })
        
        const response = await getQuestionList(params)
        console.log('fetchData - 返回的数据:', response)
        
        // 检查并处理返回的数据
        if (response && response.code === 200 && response.data) {
          this.questionList = response.data.items || []
          this.total = response.data.total || 0
          this.averageScore = response.data.avg_score || 0  // 使用后端返回的平均分
          console.log('处理后的数据:', {
            questionList: this.questionList,
            total: this.total,
            averageScore: this.averageScore
          })
        } else {
          console.error('返回数据格式不正确:', response)
          this.questionList = []
          this.total = 0
          this.averageScore = 0
        }
        
      } catch (error) {
        console.error('获取题目列表失败:', error)
        this.$message.error('获取题目列表失败')
        this.questionList = []
        this.total = 0
        this.averageScore = 0
      } finally {
        this.loading = false
      }
    },
    
    async fetchTags() {
      try {
        const { data } = await getAllTags()
        this.tags = data
        console.log('获取到的标签列表:', this.tags)
      } catch (error) {
        console.error('获取标签列表失败:', error)
      }
    },
    async fetchErrorCodes() {
      try {
        const res = await request({ url: '/api/error-codes', method: 'get' })
        if (res.code === 200) {
          this.errorCodes = res.data || []
        }
      } catch (e) {}
    },
    
    handleTagSearch(query) {
      // 实现标签搜索逻辑
      if (query) {
        this.tags = this.tags.filter(tag => 
          tag.tag_name.toLowerCase().includes(query.toLowerCase())
        )
      }
    },
    
    handleSearch() {
      // 重置页码
      this.currentPage = 1
      // 保持排序状态，传入当前筛选条件
      this.fetchData(this.filterForm)
    },
    
    handleReset() {
      // 重置筛选条件
      this.filterForm = {
        question_name: '',
        game_name: '',
        fix_status: '',
        difficulty: '',
        tags: [],
        is_collect: '',
        is_pending: ''
      }
      
      // 重置页码，并恢复默认排序
      this.currentPage = 1
      this.sortProp = 'game_time'
      this.sortOrder = 'descending'
      
      // 重新获取数据
      this.fetchData()
    },
    
    handleSortChange({ prop, order }) {
      console.log('排序变化 - 原始参数:', { prop, order })
      
      // 更新排序状态
      if (!order) {
        // 取消排序时，恢复默认排序
        this.sortProp = 'game_time'
        this.sortOrder = 'descending'
      } else {
        // 直接使用 Element UI 的排序值
        this.sortProp = prop
        this.sortOrder = order
      }
      
      // 获取当前的筛选条件并发送请求
      const params = {
        ...this.filterForm,
        sort_prop: this.sortProp,
        sort_order: this.sortOrder
      }
      
      // 添加调试日志
      console.log('排序变化 - 发送的参数:', {
        prop: this.sortProp,
        order: this.sortOrder,
        params
      })
      
      this.fetchData(params)
    },
    
    handleSizeChange(val) {
      this.pageSize = val
      // 使用当前的筛选条件重新获取数据
      this.fetchData(this.filterForm)
    },
    
    handleCurrentChange(val) {
      this.currentPage = val
      // 使用当前的筛选条件重新获取数据
      this.fetchData(this.filterForm)
    },
    
    async handleReplay(row) {
      try {
        const { data } = await getQuestionReplay(row.question_code)
        this.currentReplayInfo = data
        this.replayDialogVisible = true
      } catch (error) {
        console.error('获取复盘信息失败:', error)
        this.$message.error('获取复盘信息失败')
      }
    },
    
    handleEdit(row) {
      this.currentQuestion = { ...row }
      this.editDialogVisible = true
    },
    
    async handleCollect(row) {
      try {
        await this.$confirm(row.is_collect ? '确认取消收藏该题目吗？' : '确认收藏该题目吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        })
        
        await updateQuestionCollect(row.question_code, !row.is_collect)
        row.is_collect = !row.is_collect
        this.$message.success(row.is_collect ? '收藏成功' : '取消收藏成功')
      } catch (error) {
        if (error !== 'cancel') {
          console.error('更新收藏状态失败:', error)
          this.$message.error('操作失败')
        }
      }
    },
    
    handleSuccess() {
      this.fetchData()
    },
    normalizeErrors(errors) {
      if (!errors) return []
      // 支持后端返回数组为字符串或对象
      if (Array.isArray(errors)) return errors
      try {
        const arr = JSON.parse(errors)
        return Array.isArray(arr) ? arr : []
      } catch { return [] }
    },
    
    getDifficultyColor(level) {
      const colorMap = {
        '红题': '#F56C6C',  // 红色
        '橙题': '#E6A23C',  // 橙色
        '黄题': '#F7BA2A',  // 黄色
        '绿题': '#67C23A',  // 绿色
        '蓝题': '#409EFF',  // 蓝色
        '紫题': '#8E44AD',  // 紫色
        '黑题': '#2C3E50',  // 黑色
        '': '#909399'       // 灰色
      }
      return colorMap[level] || '#909399'
    },
    
    getTagColorByCode(tagCode) {
      // 使用与赛事页面相同的颜色映射
      const colors = {
        'tag-color-1': '#409EFF',  // Element UI 主蓝色
        'tag-color-2': '#67C23A',  // Element UI 成功绿色
        'tag-color-3': '#E6A23C',  // Element UI 警告黄色
        'tag-color-4': '#F56C6C',  // Element UI 危险红色
        'tag-color-5': '#8E44AD',  // 深紫色
        'tag-color-6': '#16A085',  // 深青色
        'tag-color-7': '#D35400',  // 深橙色
        'tag-color-8': '#2980B9',  // 深蓝色
        'tag-color-9': '#27AE60',  // 深绿色
        'tag-color-10': '#C0392B'  // 深红色
      }
      
      // 使用与赛事页面相同的索引生成方式
      const colorClasses = [
        'tag-color-1', 'tag-color-2', 'tag-color-3', 'tag-color-4', 'tag-color-5',
        'tag-color-6', 'tag-color-7', 'tag-color-8', 'tag-color-9', 'tag-color-10'
      ]
      const index = parseInt(tagCode.split('_')[1], 36) % colorClasses.length
      return colors[colorClasses[index]]
    },
    
    getTagColorByName(tagName) {
      // 根据标签名称找到对应的tag_code，然后使用getTagColorByCode生成颜色
      const tag = this.tags.find(t => t.tag_name === tagName)
      return tag ? this.getTagColorByCode(tag.tag_code) : '#909399'
    },
    
    getTagColor(tagName) {
      const tag = this.tags.find(t => t.tag_name === tagName)
      if (!tag) return '#409EFF'
      return this.getTagColorByCode(tag.tag_code)
    },
    
    getTagName(tagCode) {
      const tag = this.tags.find(t => t.tag_code === tagCode)
      return tag ? tag.tag_name : tagCode
    },
    
    // 格式化百分比
    percentageFormat(percentage) {
      return percentage.toFixed(2) + '%'
    },
    
    async handleFix(question) {
      try {
        await this.$confirm('确认将该题目订正分数改为100分吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        })
        
        const res = await request({
          url: `/api/game/question/${question.question_code}/fix`,
          method: 'put',
          data: {
            question_score_fix: 100
          }
        })
        
        if (res.code === 200) {
          this.$message.success('订正成功')
          // 更新本地数据
          question.question_score_fix = 100
          // 触发更新
          this.$emit('question-operation-complete', {
            type: 'fix',
            questionCode: question.question_code,
            score: 100
          })
        } else {
          throw new Error(res.message || '订正失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('订正失败:', error)
          this.$message.error(error.message || '订正失败')
        }
      }
    },
    
    async handlePending(row) {
      try {
        // 判断题目得分和订正分数
        if (row.question_score === 100 || row.question_score_fix === 100) {
          this.$message.warning('该题目你已经' + (row.question_score === 100 ? 'AC' : '订正') + '，无法挂起。')
          return
        }

        await this.$confirm(row.is_pending ? '确认取消挂起该题目吗？' : '确认挂起该题目吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        })
        
        const res = await request({
          url: `/api/question/${row.question_code}/pending`,
          method: 'put',
          data: {
            is_pending: !row.is_pending
          }
        })
        
        if (res.code === 200) {
          row.is_pending = !row.is_pending
          this.$message.success(row.is_pending ? '挂起成功' : '取消挂起成功')
        } else {
          throw new Error(res.message || '操作失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('挂起操作失败:', error)
          this.$message.error('操作失败')
        }
      }
    },

    getScoreColor(score) {
      if (score === undefined || score === null) return '#606266';
      const percentage = (score / 100) * 100;
      if (percentage >= 100) return '#237804'; // 绿色
      if (percentage >= 75) return '#52C41A'; // 黄绿色
      if (percentage >= 50) return '#F7BA2A'; // 黄色
      if (percentage >= 25) return '#E6A23C'; // 橙色
      return '#F56C6C'; // 红色
    },
    
    // 切换错误类型展开状态
    toggleExpandErrors(questionCode) {
      this.$set(this.expandedErrors, questionCode, !this.expandedErrors[questionCode])
    },
    
    // 切换标签展开状态
    toggleExpandTags(questionCode) {
      this.$set(this.expandedTags, questionCode, !this.expandedTags[questionCode])
    },

    getHangupTooltip(row) {
      if (row.question_score === 100) {
        return '已AC，无需挂起'
      }
      if (row.question_score_fix === 100) {
        return '已订正，无需挂起'
      }
      return row.is_pending ? '取消挂起' : '挂起'
    },

    getHangupButtonClass(row) {
      if (row.question_score === 100 || row.question_score_fix === 100) {
        return 'disabled-button'
      }
      return row.is_pending ? 'pending-active-button' : 'pending-button'
    },
    
    getErrorTagInlineStyle,
    getErrorOutlineStyle
  }
}
</script>

<style lang="scss" scoped>
.question-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  background-color: #f0f2f5;
  overflow: hidden;
  
  .filter-card {
    margin: 8px 0 0 0;
    flex-shrink: 0;
    background-color: #fff;
    position: relative;
    z-index: 10;
    height: 72px;
    
    :deep(.el-card__body) {
      height: 100%;
      padding: 0;
    }
  }
  
  .filter-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 16px;

    .left-section {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-right: 20px;
      flex-shrink: 1;
      overflow-x: auto;
      height: 100%;
      
      .filter-form {
        display: flex;
        align-items: center;
        white-space: nowrap;
        height: 100%;
        
        .form-content {
          display: flex;
          align-items: center;
          gap: 8px;
          height: 100%;
          
          :deep(.el-input),
          :deep(.el-select) {
            .el-input__inner {
              height: 32px;
              line-height: 32px;
              font-size: 13px;
            }
          }
          
          :deep(.el-button) {
            height: 32px;
            line-height: 30px;
            padding: 0 16px;
            font-size: 13px;
          }
          
          .el-form-item {
            margin-bottom: 0;
            margin-right: 0;
            display: flex;
            align-items: center;
          }

          .filter-buttons {
            margin-left: auto;
            white-space: nowrap;
            
            .el-button + .el-button {
              margin-left: 8px;
            }
          }
        }
      }
    }

    .right-section {
      display: flex;
      align-items: center;
      gap: 16px;
      flex-shrink: 0;
      padding: 0 12px;
      background-color: #f6f8fa;
      border-radius: 8px;
      height: 52px;
      
      .stat-card {
        text-align: center;
        min-width: 80px;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        padding: 0 10px;

        &:not(:last-child)::after {
          content: '';
          position: absolute;
          right: -8px;
          top: 50%;
          transform: translateY(-50%);
          height: 36px;
          width: 1px;
          background-color: #dcdfe6;
        }

        .stat-value {
          font-size: 18px;
          font-weight: 600;
          color: #1f2937;
          line-height: 1;
          margin-bottom: 4px;
        }

        .stat-label {
          font-size: 12px;
          color: #6b7280;
          line-height: 1;
        }
      }
    }
  }
  
  .table-card {
    margin: 8px 0 0 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #fff;
    border-radius: 4px;
    min-height: 0;
    
    :deep(.el-card__body) {
      height: 100%;
      padding: 0;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }
    
    :deep(.el-table) {
      flex: 1;
      height: 100%;
      
      .el-table__header-wrapper {
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: #fff;
      }
      
      .el-table__body-wrapper {
        overflow-y: auto;
        height: calc(100% - 60px);
      }
    }
  }
  
  .pagination-container {
    height: 40px;
    padding: 0 16px;
    background-color: #fff;
    border-top: 1px solid #e4e7ed;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-shrink: 0;
  }
  
  .copyright-card {
    margin: 8px 0;
    flex-shrink: 0;
    background-color: #fff;
    border-radius: 4px;
    height: 40px;
    position: relative;
    z-index: 1;
    
    :deep(.el-card__body) {
      height: 100%;
      padding: 0;
    }
    
    .copyright-content {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #909399;
      font-size: 14px;
      
      span {
        line-height: 1;
      }
    }
  }
  
  .empty-text {
    color: #909399;
    text-align: center;
    padding: 20px;
  }
  
  :deep(.el-table) {
    th {
      background-color: #f2f3f5;
      color: #606266;
      font-weight: 600;
      font-size: 14px;
      height: 52px;
      padding: 0;
    }
    
    td {
      padding: 8px 0;
    }

    .el-table__row {
      height: 52px;
    }
    
    .el-button {
      &.el-icon-edit,
      &.el-icon-document,
      &.el-icon-star-off,
      &.el-icon-star-on {
        margin: 0 2px;
        transition: all 0.3s;
        
        &:hover {
          transform: scale(1.2);
        }
      }
    }
    
    .operation-buttons {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;
      
      .operation-button {
        width: 24px;
        height: 24px;
        padding: 0;
        border-radius: 4px;
        margin: 0;
        border: none;
        transition: all 0.2s ease;
        
        i {
          font-size: 14px;
          color: white;
        }
        
        // 编辑按钮 - 深蓝色
        &.edit-button {
          background-color: #0056b3;
          
          &:hover {
            background-color: #004494;
            transform: translateY(-1px);
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          &:active {
            transform: translateY(0);
            background-color: #003d82;
          }
        }
        
        // 订正按钮 - 绿色
        &.fix-button {
          background-color: #67C23A;
          
          &:hover {
            background-color: #5daf34;
            transform: translateY(-1px);
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          &:active {
            transform: translateY(0);
            background-color: #529b2e;
          }
        }
        
        // 复盘按钮 - 紫色
        &.replay-button {
          background-color: #6f42c1;
          
          &:hover {
            background-color: #5f3a9f;
            transform: translateY(-1px);
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          &:active {
            transform: translateY(0);
            background-color: #4e2a84;
          }
        }
        
        // 收藏按钮（未收藏状态）- 蓝色
        &.collect-button {
          background-color: #409EFF;
          
          &:hover {
            background-color: #337ecc;
            transform: translateY(-1px);
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          &:active {
            transform: translateY(0);
            background-color: #2b6cb0;
          }
        }
        
        // 收藏按钮（已收藏状态）- 黄色
        &.collect-active-button {
          background-color: #F7BA2A;
          
          &:hover {
            background-color: #e6a723;
            transform: translateY(-1px);
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          &:active {
            transform: translateY(0);
            background-color: #d4951c;
          }
        }
        
        // 挂起按钮（未挂起状态）- 蓝色
        &.pending-button {
          background-color: #409EFF;
          
          &:hover {
            background-color: #337ecc;
            transform: translateY(-1px);
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          &:active {
            transform: translateY(0);
            background-color: #2b6cb0;
          }
        }
        
        // 挂起按钮（已挂起状态）- 橙色
        &.pending-active-button {
          background-color: #E6A23C;
          
          &:hover {
            background-color: #d49134;
            transform: translateY(-1px);
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          &:active {
            transform: translateY(0);
            background-color: #c08025;
          }
        }
        
        // 禁用状态按钮
        &.disabled-button {
          background-color: #F2F3F5;
          cursor: not-allowed;
          opacity: 0.6;
          
          i {
            color: #C0C4CC;
          }
          
          &:hover {
            background-color: #F2F3F5;
            transform: none;
            box-shadow: none;
          }
        }
        
        &:disabled {
          cursor: not-allowed;
          background-color: #F2F3F5;
          opacity: 0.6;
          
          i {
            color: #C0C4CC;
          }
          
          &:hover {
            transform: none;
            box-shadow: none;
          }
        }
      }
    }
  }
  
  .replay-dialog {
    :deep(.el-dialog__body) {
      padding: 20px;
      max-height: 80vh;
      overflow-y: auto;
    }
    
    .replay-content {
      width: 100%;
      
      .md-editor {
        height: auto !important;
        
        :deep(.v-note-wrapper) {
          z-index: 1;
          min-height: auto !important;
          height: auto !important;
        }
        
        :deep(.v-note-panel) {
          border: none;
          min-height: auto !important;
          height: auto !important;
        }
        
        :deep(.v-show-content) {
          background-color: #fff;
          padding: 10px;
          height: auto !important;
          min-height: auto !important;
        }
        
        :deep(.v-note-edit-wrapper),
        :deep(.v-note-show-wrapper) {
          width: 100% !important;
          height: auto !important;
        }
      }
    }
  }

  .score-cell {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  // 文本省略样式
  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    
    .link-text {
      color: #409EFF;
      text-decoration: none;
      
      &:hover {
        text-decoration: underline;
      }
    }
  }
  
  // 标签容器
  .tag-container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    
    .expand-btn {
      padding: 2px 8px;
      font-size: 12px;
      color: #409EFF;
      height: 24px;
      line-height: 22px;
      
      &:hover {
        background-color: #ecf5ff;
        border-radius: 4px;
      }
    }
  }
}

/* .vertical-center-dialog 已在 App.vue 中全局定义，不需要重复定义 */
</style>

<!-- 添加全局样式用于tooltip -->
<style>
.difficulty-tooltip {
  max-width: 600px !important;
}

.difficulty-tooltip-content {
  max-height: none;
  overflow-y: visible;
  padding: 0;
}

.difficulty-tooltip-content .difficulty-description {
  line-height: 1.6;
  font-size: 13px;
}

.difficulty-tooltip-content .difficulty-description p {
  margin: 8px 0;
  color: #ffffff;
}

.difficulty-tooltip-content .difficulty-description p strong {
  color: #409EFF;
  font-weight: 600;
}

.difficulty-tooltip-content .difficulty-description ul {
  margin: 4px 0 8px 0;
  padding-left: 16px;
}

.difficulty-tooltip-content .difficulty-description li {
  margin: 2px 0;
  color: #e6e6e6;
  font-size: 12px;
}

/* 操作列背景样式 */
::v-deep .operation-column .cell {
  background-color: rgba(248, 249, 250, 0.6) !important;
  padding: 8px 4px !important;
}
</style>

<style lang="scss">
// 全局样式 - 限制题目复盘对话框最大宽度
.el-dialog__wrapper .question-replay-dialog-width-limit {
  width: 50% !important;
  max-width: 800px !important;
  margin: 0 auto !important;
}

.question-replay-dialog-width-limit.el-dialog {
  width: 100% !important;
}
</style>
 